import { DropdownFilter } from 'src/app/views/filter-drop-down/filter-drop-down.component';
import { SortCategories } from 'src/app/views/sort-elements/sort-drop-down/sort-drop-down.helpers';
import { RelationRequestTables } from '../../grid-table-factory/table-creator.enum';

import { INITIAL_PAGINATION, ListMode, ListState } from '../../../shared/list-controller/list-controller';
import { RelationPageTabs, RelationRequestKnd } from '../../relation-request.enum';
import {
  ConnectionRequest,
  RelationRequestPageTexts,
  RelationRequestsPageConfig,
} from '../../relation-request.interface';
import { RelationRequestsTables } from '../../relation-request.tokens';
import { ManageRelationRequestComponent } from '../manage-relation-request/manage-relation-request.component';

export class ConnectionRequestComponent extends ManageRelationRequestComponent<ConnectionRequest, UserRolesFilter> {}

export const CONNECTION_TABLES: RelationRequestsTables = {
  [RelationPageTabs.LIST]: RelationRequestTables.CONNECTION_REQUESTS,
  [RelationPageTabs.REQUESTS_RECEIVED]: RelationRequestTables.CONNECTIONS_RECEIVED_INVITES,
  [RelationPageTabs.REQUESTS_SENT]: RelationRequestTables.CONNECTIONS_SENT_REQUESTS,
};

const CONNECTION_PAGE_TEXTS: RelationRequestPageTexts = {
  noAcceptedRequestsHint: 'CURRENT_USER_NO_CONNECTIONS_YET',
  noReceivedRequestsHint: 'CONNECTIONS_NO_NEW_GOT_INVITES_TEXT',
  noSentRequestsHint: 'CONNECTIONS_NO_NEW_SENT_REQUESTS_TEXT',
  acceptedRequestsTabTitle: 'CONNECTIONS_MY_CONNECTIONS_TAB_HINT',
  searchFieldLabel: 'SEARCH_CONNECTION_FIELD_LABEL',
};

export type UserRolesFilter =
  | ''
  | 'role_doctor'
  | 'role_medstaff'
  | 'role_patient'
  | 'role_researcher'
  | 'role_organization';

export enum FiltersByRole {
  ALL = '',
  DOCTOR = 'role_doctor',
  MEDSTAFF = 'role_medstaff',
  PATIENT = 'role_patient',
  RESEARCHER = 'role_researcher',
  ORGANIZATION = 'role_organization',
}

export enum FilterTitleByRoles {
  ALL = 'FILTER_ALL',
  DOCTOR = 'FILTER_DOCTOR',
  MEDSTAFF = 'FILTER_MEDSTAFF',
  PATIENT = 'FILTER_PATIENT',
  RESEARCHER = 'FILTER_RESEARCHER',
  ORGANIZATION = 'FILTER_ORGANIZATION',
}

export const CONNECTION_FILTER_OPTIONS: DropdownFilter<UserRolesFilter> = {
  name: 'FILTER_BY_ROLE',
  options: [
    {
      title: FilterTitleByRoles.ALL,
      value: FiltersByRole.ALL,
    },
    {
      title: FilterTitleByRoles.DOCTOR,
      value: FiltersByRole.DOCTOR,
    },
    {
      title: FilterTitleByRoles.MEDSTAFF,
      value: FiltersByRole.MEDSTAFF,
    },
    {
      title: FilterTitleByRoles.PATIENT,
      value: FiltersByRole.PATIENT,
    },
    {
      title: FilterTitleByRoles.RESEARCHER,
      value: FiltersByRole.RESEARCHER,
    },
    {
      title: FilterTitleByRoles.ORGANIZATION,
      value: FiltersByRole.ORGANIZATION,
    },
  ],
};

const CONNECTION_INITIAL_STATE: ListState<RelationPageTabs, UserRolesFilter> = {
  context: RelationPageTabs.LIST,
  pagination: INITIAL_PAGINATION,
  sorting: SortCategories.SCORE_DESC,
  filtering: FiltersByRole.ALL,
  mode: ListMode.BROWSE,
  queryKeyword: '',
};

export const CONNECTION_PAGE_CONFIG: RelationRequestsPageConfig<UserRolesFilter> = {
  kind: RelationRequestKnd.CONNECTION,
  texts: CONNECTION_PAGE_TEXTS,
  filter: CONNECTION_FILTER_OPTIONS,
  initialState: CONNECTION_INITIAL_STATE,
  allowedChat: true,
};
